import { render, staticRenderFns } from "./TreasureHuntPage.vue?vue&type=template&id=2f585c02&scoped=true"
import script from "./TreasureHuntPage.vue?vue&type=script&lang=js"
export * from "./TreasureHuntPage.vue?vue&type=script&lang=js"
import style0 from "./TreasureHuntPage.vue?vue&type=style&index=0&id=2f585c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f585c02",
  null
  
)

export default component.exports